import React, { forwardRef, InputHTMLAttributes } from 'react';

import { usePlacesWidget } from 'react-google-autocomplete';

import config from 'utils/config';
import { noop } from 'utils/noop';

import TextInput from './TextInput';

interface BaseAutocompleteInputProps extends InputHTMLAttributes<HTMLInputElement> {
    labelText?: string;
    row?: boolean;
    onPlaceSelected?: (place: google.maps.places.PlaceResult) => void;
}
interface ErrorAutocompleteInputProps extends BaseAutocompleteInputProps {
    errorText?: string;
    helperText?: never;
}
interface HelperAutocompleteInputProps extends BaseAutocompleteInputProps {
    errorText?: never;
    helperText?: string;
}
type AutocompleteInputProps = ErrorAutocompleteInputProps | HelperAutocompleteInputProps;

const AutocompleteInput = forwardRef(
    (
        { onPlaceSelected = noop, ...inputProps }: AutocompleteInputProps,
        ref: React.Ref<HTMLInputElement>,
    ): JSX.Element => {
        // Hack: Googel maps api is not working on some environments
        const hostname = window.location.hostname;
        const skipHostnames = ['localhost', 'deploy-preview'].some((host) => hostname.includes(host));

        const apiKey = config.googleMapsApiKey;

        let inputRef = ref;
        if (!!apiKey && !skipHostnames) {
            // TODO: check or fix hooks error
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const { ref: autocompleteRef } = usePlacesWidget({
                apiKey: apiKey,
                onPlaceSelected: onPlaceSelected,
                options: {
                    types: ['address'],
                    componentRestrictions: { country: 'us' },
                },
                inputAutocompleteValue: inputProps.autoComplete,
            });
            inputRef = autocompleteRef as unknown as React.Ref<HTMLInputElement>;
        }
        return <TextInput {...inputProps} ref={inputRef} />;
    },
);

AutocompleteInput.displayName = 'AutocompleteInput';
export default AutocompleteInput;
